import { Constants as ServerSide } from 'actions/ssr'

/*
 * Higher-Order Reducer
 * next-redux-wrapper & HYDRATE Action
 * https://github.com/kirill-konshin/next-redux-wrapper#state-reconciliation-during-hydration
 * We need to have a GLOBAL Reducer/Event for STATE reconciliation during hydration
 *
 * > The payload of this action will contain the state at the moment of static generation or server side rendering,
 * so your reducer must merge it with existing client state properly.
 *
 * We accept one action HYDRATE everything else run through the APP reduce like NORMAL
 */
const ssrHOC = (appReducer: (...args: Array<any>) => any): Record<string, any> => {
  return (state: Record<string, any> = {}, action: Record<string, any>): Record<string, any> => {
    switch (action.type) {
      case ServerSide.SSR_COMPLETE: {
        // For OPS or Apps that require session, we will already setup
        // So if no PAYLOAD, skip
        if (!action.payload) {
          return state
        }

        // Merge API data in
        const {
          abTest,
          cart,
          client,
          cookie,
          featureFlags,
          isMobileTraffic,
          locale,
          session,
          storeLocale,
        } = action.payload
        const newState = {
          ...state,
          shared: { ...state.shared, client, featureFlags, isMobileTraffic, locale, storeLocale },
          user: { ...state.user, abTest, cart, cookie, session },
        }
        return newState
      }

      case 'INIT':
      default:
        return appReducer(state, action)
    }
  }
}

export default ssrHOC